import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import PopupVillage from './PopupVillage';
import { FORM_VALUES } from '../../../utils/helpers/constants';
import { Selector } from '../../ui/Selector';

const SelectVillage = ({
  setInitCoordinates,
  villagePopupIsOpen,
  toggleHandlerVillage
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const selectedVillage = values[FORM_VALUES.villageName];

  return (
    <>
      <Selector
        value={selectedVillage}
        cypress="village-select"
        title={t('new_ad.village')}
        name={FORM_VALUES.villageId}
        onClick={toggleHandlerVillage}
      />
      <PopupVillage
        isOpen={villagePopupIsOpen}
        closeHandler={toggleHandlerVillage}
        setInitCoordinates={setInitCoordinates}
      />
    </>
  );
};

SelectVillage.propTypes = {
  setInitCoordinates: PropTypes.func.isRequired,
  villagePopupIsOpen: PropTypes.bool.isRequired,
  toggleHandlerVillage: PropTypes.func.isRequired
};

export default memo(SelectVillage);
